var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{ 'btn-primary': _vm.isOn, 'btn-secondary': !_vm.isOn},domProps:{"innerHTML":_vm._s(_vm.isOn ? `<strong>${_vm.labels[1]}</strong>` : _vm.labels[0])},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }